import type { Page } from '@/components/canvas/document/publicTypes';
import type { ExportOptions } from './types';
import { drawBackground } from '@/components/canvas/page/exportBackground';
import { drawElement } from './drawElement';

/**
 * 将画布数据渲染为 data URL（PNG 或 JPEG）。
 * 无需 DOM，可在 Web Worker 中运行（除图片加载外）。
 */
export async function renderCanvasToDataURL(
  page: Page,
  options: ExportOptions = {}
): Promise<string> {
  const { scale = 1, format = 'png', quality = 0.92, getImageProxyUrl } = options;

  const { width, height } = page.size;
  const offscreen = document.createElement('canvas');
  offscreen.width = Math.round(width * scale);
  offscreen.height = Math.round(height * scale);
  const ctx = offscreen.getContext('2d');
  if (!ctx) throw new Error('Canvas 2D context unavailable');

  ctx.scale(scale, scale);

  await drawBackground(ctx, page.background, width, height, getImageProxyUrl);

  const rootElements = page.elements
    .filter((el) => el.interaction.visible !== false && !el.layout.parentId)
    .sort((a, b) => a.layout.zIndex - b.layout.zIndex);

  for (const el of rootElements) {
    await drawElement(ctx, el, page.elements, getImageProxyUrl);
  }

  return offscreen.toDataURL(format === 'jpeg' ? 'image/jpeg' : 'image/png', quality);
}
